import React, { Component } from "react";
import ContentWrapper from "../../../components/common/ContentWrapper";
import Card from "../../../components/common/Card";
import CardHeader from "../../../components/common/CardHeader";
import CardBody from "../../../components/common/CardBody";
import CardTitle from "../../../components/common/CardTitle";
import AdminTemplate from "../../../components/admin/layouts/Template";
import Breadcrumbs from "./Breadcrumbs";
import HirearchyCard from "./HirearchyCard";
import TabSection from "./TabSection.js";
import Grid from "@mui/material/Grid";
import { Tabs, Tab } from "@mui/material";
import CustomEditor from "../../../pages/manage/enrollment/CustomEditor.js";
import AddCard from "./AddCard";
import "./hirearchy.css";
import { TreeMainService } from "../../../service/manage/h_tree/tree_main.service";
import { history } from "../../../helper/history";
import {
  Row,
  Col,
  Spinner,
  Button,
  Form,
  Modal
} from "react-bootstrap";
import PageSpinner from "../../../components/common/spinner/PageSpinner";
import { sweetSuccessAlert,sweetStatusAlert, sweetConfirmAlert } from "../../../components/common/SweetAlert";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import { ChatService } from "../../../service/manage/chat/chat.service";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import ListItemIcon from '@mui/material/ListItemIcon';
import Checkbox from '@mui/material/Checkbox';
import Avatar from '@mui/material/Avatar';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import ErrorIcon from '@mui/icons-material/Error';
import {convertToRaw, EditorState,convertFromRaw } from "draft-js";
import {Editor} from "react-draft-wysiwyg";
import { ProgressService } from "../../../service/manage/progress_catchup/progress.service.js";
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Typography from '@mui/material/Typography';
import SimpleReactValidator from "simple-react-validator";
import { NodeGroupService } from "../../../service/settings/manage/node_group_title.service.js";
import Divider from '@mui/material/Divider';
import "./Search.css"
import Slider from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import GridViewRoundedIcon from '@mui/icons-material/GridViewRounded';
import {formFixture} from './FormFixture'
import config from '../../../helper/config';
import {customerConstants} from "../../../helper/constants.js";
import queryString from 'query-string';
import { CombankService } from "../../../service/manage/subscription/combank_pg.service.js";
import {MainContext} from "../../../context/main/main-context.js"

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

let addBtnStyle, closeBtnStyle
const customer = getCustomerFeatureFlag()
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    break
  case customerConstants.EXO_CUSTOMER2:
    closeBtnStyle = {
      color: "var(--maincolor-cmc)",
      backgroundColor: "#E5F5FF",
      borderColor: "transparent"
    }
    addBtnStyle = {
      color: "#fff",
      backgroundColor: "var(--maincolor-cmc)",
      borderColor: "transparent"
    }
    break
  default:
    break
}

class searchComponent extends Component {

  static contextType = MainContext

  constructor(props) {
    super(props);
    this.createValidationsInstance();
    this.state = {
      cardData: [],
      nodesData: [],
      hierarchyGridTopData: [],
      hierarchyGridBottomData: [],
      loadingNode: false,
      formModalLoading: true,
      showInsertModal: false,
      showUpdateModal: false,
      mcode: "",
      title: "",
      groupTitle: "",
      highlightCard: "",
      flg_node_hide: 0,
      pid: null,
      displayOrder: 1,
      data_id: null,
      insertType: "null",
      selectedAttributes: [], // Initialize selected attributes as an empty array
      previousAttributes: [], // Attributes that are assigned already for a specific node
      mid: "",
      user_id: null,
      user_table_id: null,
      showAboutUpdateModal:false,
      about:null,
      isAboutLoading:false,
      about_details:null,
      contentEditorState: EditorState.createEmpty(),
      showChatModal:false,//main chat modal
      chat:null,//which are passing through state of db function
      chat_details:null,//chat details of main db
      showGroupChatAdd:false,// chat create modal
      studentList:[],// student list of node (enrolled)
      chatName:'',
      createChatLoading:false,
      chat_server_details:null,
      chat_backDrop:false,
      checked:[],
      memberListLoading:false,
      showProgressModal:false,
      progress : null,
      progress_details:[],
      showProgressCreateModal:false,
      start_date:"",
      end_date:"",
      progress_loading:false,
      date:"",
      steps:[],
      percentage:null,
      comment:"",
      marks:[],
      dayArray:[],
      todayIndex:0,
      isCardSectionVisible: false,
      isMobile: window.innerWidth <= 900,
      titles:[],
      selectedMidsParents:null,//array
      selectedMid:null,//obj
      selectedMidsChilds:null,//array
      selectedMidsForms:null,//array
      selectedMidsSelectedForm:null,//obj
      selectedFormDetail:null,
      formLoading:false,
      paymentStatus:undefined,
      hierarchyCardInsertion:false,
      root_node_id:undefined,
      isHideForExam: true
    };

    this.onContentEditorChange = this.onContentEditorChange.bind(this)
  };

  toggleCardSection = () => {
    this.setState((prevState) => ({
      isCardSectionVisible: !prevState.isCardSectionVisible
    }))
  }

  setIsHideForExam = (bool) => {
    this.setState(() => ({
      isHideForExam: !!bool
    }))
  }

  setFormDetail = (formDetail) => {
    this.redirect(this.state.selectedMid.pid, formDetail.node_mid, formDetail.form_list_id)
    this.setState({
      selectedFormDetail: formDetail
    })
  }

  onContentEditorChange(editorState) {
    this.setState({
      contentEditorState: editorState
    })
  }

  redirectToSubscriptions(query){
    const newQueryString = query.toString();
    const newUrl = newQueryString ? window.location.pathname + '?' + newQueryString : window.location.pathname;
    window.history.replaceState({}, document.title, newUrl);

    const state = {
      privilege_edit: 1,
      privilege_add: 1,
      privilege_delete: 1,
      nodeTitle: 'Subscriptions',
      mid: 100,
      main_table_id:10,
      owner_restriction: null,
      lg_user_id: sessionStorage.getItem("manage_user_id"),
      lg_user_table_id: sessionStorage.getItem("table_log_id"),
      user_list_restriction: null
    };

    history.push({
      pathname: "/subscriptions",
      state: { ...state },
    });
  }

  handlePaymentResponse(){
    const query = new URLSearchParams(window.location.search);
    const success = query.get('success');
    const cancel = query.get('cancel');
    const userType = sessionStorage.getItem("userType");
    if (success === 'true') {
      if (customerConstants.EXO_CUSTOMER2 === getCustomerFeatureFlag()) {
        query.delete('success');
        sweetStatusAlert("Success!", "Your payment was successful!", "success");
        this.redirectToSubscriptions(query);        
      } else {
        CombankService.retrieveOrder(sessionStorage.getItem("checkout_session_id"))
        .then((response)=>{
          sessionStorage.removeItem('checkout_session_id');
          query.delete('success');
          sweetStatusAlert("Success!", "Your payment was successful!", "success");
          if(userType !== 'admin'){
            this.redirectToSubscriptions(query);
          }else{
            const newQueryString = query.toString();
            const newUrl = newQueryString ? window.location.pathname + '?' + newQueryString : window.location.pathname;
            window.history.replaceState({}, document.title, newUrl);
            return true;
          }
        });
      }
    } else if (cancel === 'true') {
        query.delete('cancel');
        sweetStatusAlert(
            "Failed!",
            "Your payment is failed!",
            "error"
        );
        if(userType !== 'admin'){
          this.redirectToSubscriptions(query);
        }else{
          const newQueryString = query.toString();
          const newUrl = newQueryString ? window.location.pathname + '?' + newQueryString : window.location.pathname;
          window.history.replaceState({}, document.title, newUrl);
          return true;
        }
    }
    return false;
  }

  componentDidMount() {
    const status = this.handlePaymentResponse();
    let user_id = sessionStorage.getItem("manage_user_id")
    let user_table_id = sessionStorage.getItem("table_log_id")
    let root_node_id = !!sessionStorage.getItem("root_node_id") ? sessionStorage.getItem("root_node_id") : 100
    let mid = !!(history.location.state && history.location.state.pid) ? history.location.state.pid : (status ? 10 : root_node_id)
    this.getAllNodeGroupTitls()
    // const queryParams = new URLSearchParams(window.location.search);
    let fmid = queryString.parse(this.props.location.search).fmid
    fmid = fmid && parseInt(fmid);
    let smid = queryString.parse(this.props.location.search).smid
    smid = smid && parseInt(smid);
    let formid = queryString.parse(this.props.location.search).formid
    formid = formid && parseInt(formid);
    mid = fmid ? fmid : mid
    this.getDashboardStats(mid, 1, user_id, user_table_id, smid, formid)
    this.setState({
      user_id: user_id,
      user_table_id: user_table_id,
      root_node_id:root_node_id
    })
    window.addEventListener("resize", this.handleResize)
    this.handlePaymentResponse();
  }

  componentDidUpdate(prevProps, prevState){
    let root_node_id_state = this.state.root_node_id
    let root_node_id_session = sessionStorage.getItem("root_node_id")
    if(root_node_id_session !== root_node_id_state){
      this.setState({
        root_node_id:root_node_id_session
      })
      root_node_id_state=root_node_id_session
    }
    let mid = !!(history.location.state && history.location.state.pid) ? history.location.state.pid : root_node_id_state
    let prevfmid = queryString.parse(prevProps.location.search).fmid
    prevfmid = prevfmid && parseInt(prevfmid);
    let currentfmid = queryString.parse(this.props.location.search).fmid;
    currentfmid = currentfmid && parseInt(currentfmid);
    mid = currentfmid ? currentfmid : mid

    let prevsmid = queryString.parse(prevProps.location.search).smid
    prevsmid = prevsmid && parseInt(prevsmid);
    let currentsmid = queryString.parse(this.props.location.search).smid;
    currentsmid = currentsmid && parseInt(currentsmid);

    let prevformid = queryString.parse(prevProps.location.search).formid
    prevformid = prevformid && parseInt(prevformid);
    let currentformid = queryString.parse(this.props.location.search).formid;
    currentformid = currentformid && parseInt(currentformid);

    // if (prevfmid !== currentfmid && prevfmid !== undefined) {
    //   this.getDashboardStats(currentfmid, 1, this.state.user_id, this.state.user_table_id, currentsmid, currentformid)
    // }else if(prevsmid !== currentsmid && prevsmid !== undefined && currentsmid !== undefined){
    //   this.selectNode(currentsmid, 1, this.state.user_id, this.state.user_table_id, this.state.hierarchyGridBottomData, currentformid)
    // }else if(prevformid !== currentformid && prevformid !== undefined ){
      
    // }
    const {form_array} = this.context
    
    if(prevsmid !== currentsmid && prevsmid !== undefined && currentsmid !== undefined){
      this.setState({
        selectedMidsForms: form_array.data,
        formLoading:false,
      })
    }

    
    if (prevState.selectedMidsForms !== form_array.data) {
      console.log("=========form_array==========");
        console.log(form_array);
      this.setState({
        selectedMidsForms: form_array.data,
        formLoading:false,
      },()=>{ 
        console.log("=========selectedMidsForms==========");
        console.log(this.state.selectedMidsForms);
        
        
      })
    }

    
  }


  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize)
  }

  handleResize = () => {
    this.setState({
      isMobile: window.innerWidth <= 900,
    })
  }

  handleApplicationSelect = (formData) => {
    if(!formData){
      return undefined
    }
    let state = {
      pid: this.state.selectedMid.pid,
      mid: formData.node_mid,
      lg_user_id: formData.lg_user_id,
      lg_user_table_id: formData.lg_user_table_id,
      flg_list_active: formData.flg_list_active,
      privilege_view: formData.privilege_view,
      privilege_edit: formData.privilege_edit,
      privilege_add: formData.privilege_add,
      privilege_delete: formData.privilege_delete,
      owner_restriction: formData.owner_restriction,
      user_list_restriction: formData.user_list_restriction,
      form_display_title: formData.form_display_title,
      form_display_order: formData.form_display_order,
      form_list_id: formData.form_list_id,
      breadcrumb1: formData.breadcrumb1,
      breadcrumb2: formData.breadcrumb,
      main_table_id: formData.main_table_id,
      nodeTitle:this.state.selectedMid.title,
      node_mid_actual:formData.node_mid_actual,
      path:'node',
      mcode:this.state.selectedMid.mcode
    };
    const findComponent = (id, state) => {
      return formFixture(state).find(item => id === item.formListId)
    }
    const selectedComponent = findComponent(formData.form_list_id, state)
    const nodeProps = {
      getDashboardStats :()=>this.getDashboardStats(
        this.state.selectedMid.pid,
        1,
        this.state.user_id,
        this.state.user_table_id,
        formData.node_mid,
        formData.form_list_id),
        selectNode :()=>this.selectNode(formData.node_mid, -1,this.state.user_id,this.state.user_table_id, this.state.hierarchyGridBottomData, formData.form_list_id),
        setIsHideForExam: (bool)=>this.setIsHideForExam(bool)
    }
    // this.redirect(this.state.selectedMid.pid, formData.node_mid, formData.form_list_id)
    if(selectedComponent && selectedComponent.component){
      return selectedComponent.component(nodeProps)
    }
    return undefined
  };
  
  createValidationsInstance() {
    this.validator = new SimpleReactValidator({
      validators: {
        dateAfter: {
          message: "The :attribute must greater than today and start date",
          rule: (val, params, validator) => {
            return new Date(val) >= new Date() && new Date(val) > new Date(this.state.start_date);
          },
          messageReplace: (message, params) =>
            message.replace(":values", this.helpers.toSentence(params)), // optional
          required: true,
        },
        dateLastProgressAfter: {
          message: "The :attribute between last updated date and today",
          rule: (val, params, validator) => {
            const lastUpdatedDate = new Date(this.state.progress_details[this.state.progress_details?.length - 1]?.date).getTime();
            return new Date(val).getTime() > lastUpdatedDate && new Date(val).getTime() <= new Date().getTime()
                      },
          messageReplace: (message, params) =>
            message.replace(":values", this.helpers.toSentence(params)), // optional
          required: true,
        },
        percentageAfter: {
          message: "The :attribute between latest percentage and 100%",
          rule: (val, params, validator) => {
            return val <= 100 && val > this.state.progress_details[this.state.progress_details?.length-1]?.percentage
                      },
          messageReplace: (message, params) =>
            message.replace(":values", this.helpers.toSentence(params)), // optional
          required: true,
        },
      }
    });
  }

  setRootNodeToSession = async(user_id,user_table_id)=>{
    try {
      const regInfo = await TreeMainService.getRegistrationInfo(user_id,user_table_id)
      sessionStorage.setItem("root_node_id", regInfo.data[0].parent_node_id);      
    } catch (error) {
      console.log(error)
    }

  }

  handleSubmit = async (event) => {
    event.preventDefault();
    if (!this.validator.fieldValid('groupTitle') || !this.validator.fieldValid('mcode') || !this.validator.fieldValid('title')) {
      this.validator.showMessages();
      this.forceUpdate();
    } else {
      sweetConfirmAlert()
        .then(async()=>{
        this.setState({ isLoading: true });
        const child = {
          user_id:this.state.user_id,
          user_table_id:this.state.user_table_id,
          pid: this.state.pid,
          mcode: this.state.mcode,
          group_title: this.state.groupTitle,
          title: this.state.title,
          flg_node_hide: this.state.flg_node_hide,
          insert_type: this.state.insertType,
          display_order: !!this.state.displayOrder ? this.state.displayOrder : 0,
        };

        await TreeMainService.insertHierarchyNode(child)
          .then(async(response) => {
            this.setState({ isLoading: false });
            this.setState({ showInsertModal: false });
            sweetStatusAlert("Success!", 'Node added successfully', "success");
            if(this.state.hierarchyCardInsertion){
              this.redirect(this.state.pid)
            }
            else{
              this.getDashboardStats(
                this.state.pid,
                1,
                this.state.user_id,
                this.state.user_table_id
              );
            }
            await this.setRootNodeToSession(this.state.user_id, this.state.user_table_id)

            this.setState(() => ({
              mcode: "",
              title: "",
              groupTitle: "",
              flg_node_hide: 0,
              pid: null,
              displayOrder: 1,
              data_id: null,
              insertType: "null",
              hierarchyCardInsertion:false
            }));
          })
          .catch((error) => {
            this.setState({ isLoading: false });
            sweetStatusAlert("Failed!", "Unable to insert the node", "error");
            });
          })
      
    }
  };

  handleChange = (event) => {
    let { name, value } = event.target
    if ((value<0) && name === "displayOrder") {
      value = 0;
    }
    if (name === "flg_node_hide") {
      value = event.target.checked ? 1 : 0
    }
    this.setState({ [name]: value })
  }

  toggleModal = (isIntermediate = false, pid = this.state.pid, hierarchyCardInsertion =false) => {
    this.validator.hideMessages()
    this.validator.purgeFields();
    this.setState((prevState) => {
      if (!prevState.showInsertModal && isIntermediate) {
        return {
          showInsertModal: !prevState.showInsertModal,
          pid: this.state.hierarchyGridTopData[
            this.state.hierarchyGridTopData.length - 1
          ].mid,
          insertType: "L",
          hierarchyCardInsertion
        }
      }
      this.getAllNodeGroupTitls()
      return {
        showInsertModal: !prevState.showInsertModal,
        insertType: "null",
        pid: pid,
        hierarchyCardInsertion
      }
    })
    if (this.state.showInsertModal) {
      this.setState((prev) => ({
        pid: prev.data_id,
      }))
    }
  }

  getAllNodeGroupTitls(){
    NodeGroupService.getNodeGroups()
      .then((response)=>{
      if(response.success){
        this.setState({titles:response.data})
      }
    })
  }

  handleUpdateSubmit = async (event) => {
    event.preventDefault();
    if (!this.validator.fieldValid('groupTitle') || !this.validator.fieldValid('mcode') || !this.validator.fieldValid('title')) {
      this.validator.showMessages();
      this.forceUpdate();
    } else {
      this.setState({ isLoading: true });
      const child = {
        mid: this.state.mid,
        mcode: this.state.mcode,
        group_title: this.state.groupTitle,
        title: this.state.title,
        flg_node_hide: this.state.flg_node_hide,
        display_order: !!this.state.displayOrder ? this.state.displayOrder : 0 ,
      }
      await TreeMainService.updateNodeDetails(child)
        .then((response) => {
          this.setState({ isLoading: false })
          this.setState({ showUpdateModal: false })
          sweetStatusAlert("Success!", "Node updated successfully", "success")
          this.getDashboardStats(
            this.state.pid,
            1,
            this.state.user_id,
            this.state.user_table_id
          )
          this.setState(() => ({
            mcode: "",
            title: "",
            groupTitle: "",
            flg_node_hide: 0,
            pid: null,
            mid: null,
            displayOrder: 1,
            data_id: null,
          }))
        })
        .catch((error) => {
          this.setState({ isLoading: false });
          sweetStatusAlert("Failed!", "Unable to insert the node", "error");
        });
    }
  };

  toggleUpdateModal = (row) => {
    this.setState(
      (prevState) => ({
        showUpdateModal: !prevState.showUpdateModal,
      }),
      () => {
        // State has changed, perform your logic here based on the state change
        if (this.state.showUpdateModal) {
          this.getAllNodeGroupTitls()
          this.setState({
            mid: row.mid,
            title: row.title,
            mcode: row.mcode,
            groupTitle: row.group_title,
            displayOrder: row.display_order,
            flg_node_hide: row.flg_node_hide,
          })
        }
      }
    )
  }

  setNodeLoading = (param) => {
    this.setState({ loadingNode: param })
  }

  getDashboardStats = async (child_id, exclude_id, user_id, user_table_id, selectedNode=undefined, formId=undefined) => {

    this.setState((prev) =>{
      if(prev.isCardSectionVisible){
        return {isCardSectionVisible:false}
      }
    })
    this.redirect(child_id, selectedNode, formId)
    this.setState({ loadingNode: true, formLoading:true, isHideForExam:true });
    TreeMainService.getHierarchy(child_id, 1, user_id, user_table_id)
      .then((res) => {
        let hierarchyGridTopData = res.data.filter(
          (row) => row.grid_id === 0 //&& row.mid !== 100
        )
        let hierarchyGridBottomData = res.data.filter(
          (row) => row.grid_id === 1 
        );
        let selectedMidData = !!hierarchyGridBottomData.length ? hierarchyGridBottomData.find(midData => midData.mid === selectedNode):undefined
        
        console.log("hierarchyGridTopData",hierarchyGridTopData);
        
        this.setState({
            nodesData: res.data,
            hierarchyGridTopData:  hierarchyGridTopData,
            selectedMid:selectedMidData ? selectedMidData :hierarchyGridBottomData[0],
            data_id: child_id,
            pid: child_id,
          }, () => {
            if(!!selectedNode){
              this.selectNode(selectedNode, exclude_id, user_id, user_table_id, hierarchyGridBottomData, formId).then(()=>{})
            }else{
              hierarchyGridBottomData[0] ? this.selectNode(hierarchyGridBottomData[0].mid, exclude_id, user_id, user_table_id, hierarchyGridBottomData, formId).then(()=>{}) :this.setState({ loadingNode: false, formLoading:false });
            }
        })
      })
      .catch((error) => {
        this.setState({ loadingNode: false });
      });
  };



  setFormFromFormsList = (selectedMidsForms=[], formId) => {
    return selectedMidsForms.find((form) =>form.form_list_id === parseInt(formId))
  }

  selectNode = async(selecetedMid, exclude_id, user_id, user_table_id, nodeArray, formId=undefined) => {

    const {set_node_array, set_form_array, get_all_forms, form_array} = this.context

    this.setState((prev) =>{
      if(prev.isCardSectionVisible){
        return {isCardSectionVisible:false}
      }
    })
    this.redirect(nodeArray[0].pid,selecetedMid,formId)
    this.setState({ loadingNode: true, formLoading: true, highlightCard: selecetedMid,})

    try {
      await get_all_forms(selecetedMid,-1, user_id, user_table_id)

    } catch (error) {
      console.error('Error fetching forms:', error);
      this.setState({ formLoading: false });
    }

    

    // TreeMainService.getHierarchyForms(selecetedMid, user_id, user_table_id)
    //   .then((res) => {
    //     const selectedForm = this.setFormFromFormsList(res.data, formId)
    //     const assignedForm = !!selectedForm ? selectedForm :(!!res.data.length ? res.data[0] : null)
    //     if(assignedForm){
    //       this.redirect(nodeArray[0].pid, selecetedMid, assignedForm.form_list_id)
    //     }
    //     set_form_array(res.data)
    //     this.setState({
    //       selectedMidsForms: res.data,
    //       selectedFormDetail: assignedForm,
    //       formLoading:false,
    //     })
    //   })
    //   .catch((error) => {
    //     this.setState({
    //       formLoading:false,
    //       selectedMidsForms: [],
    //     });
    //   });

    TreeMainService.getHierarchy(selecetedMid, 1, user_id, user_table_id).then((res_)=>{
        this.setState({ loadingNode: true });

        let hierarchyGridBottomData = res_.data.filter(
          (row) => row.grid_id === 1 
        );

        let hierarchyGridBottomDataModified = nodeArray.map((row) => {
          if(row.mid === selecetedMid){
            return { ...row, formArray: hierarchyGridBottomData }
          }
          return{ ...row, formArray: [] }
        })
        console.log("hierarchyGridBottomData",hierarchyGridBottomData);
        console.log("hierarchyGridBottomDataModified",hierarchyGridBottomDataModified);
        set_node_array(hierarchyGridBottomDataModified)
        this.setState({
          selectedMidsChilds:  hierarchyGridBottomData,
          hierarchyGridBottomData:hierarchyGridBottomDataModified,
          loadingNode: false
        });

      })
      .catch((error) => {
        this.setState({
          loadingNode: false,
        });
      });

  }

  getAboutDetails = async (node_mid) => {
    TreeMainService.getAboutInfo(node_mid)
      .then((response) => {
        this.setState({ about_details: response.data, isAboutLoading: false })
        const existingContent = JSON.parse(response.data.text)
        let editorStateWithExistingContent = EditorState.createWithContent(
          convertFromRaw(existingContent[0])
        )
        this.setState({ contentEditorState: editorStateWithExistingContent })
      })
      .catch((error) => {
        this.setState({ isAboutLoading: false })
      })
  }

  toggleAboutModal = (about) => {
    if(this.state.showAboutUpdateModal){
      this.setState({
        showAboutUpdateModal: false,
        contentEditorState: null
      })
    }
    else{
      this.setState({
        selectedFormDetail:null,
      }, 
      ()=>{
        this.setState({showAboutUpdateModal: true, }, () => {
        this.setState({ about: about, isAboutLoading: true,})
        this.getAboutDetails(about.mid)
      })          
      })
    }
  }

  updateChatState = (newValue, key) => {
    this.setState({ chat_server_details: newValue })
  }

  getChatDetails = async (node_mid, lg_user_id, lg_user_table_id) => {
    TreeMainService.getChatInfo(node_mid, lg_user_id, lg_user_table_id)
      .then((response) => {
        this.setState(
          (prevState) => ({
            chat_details: response.data,
            chat: {
              ...prevState.chat,
              lg_user_id: response.data.lg_user_id,
              lg_user_table_id: response.data.lg_user_table_id,
            },
          }),
          () => {
            if (response.data.chatId) {
              //need to get chat details from mongo by passing chatid from response.data
              ChatService.getChat(response.data.chatId)
                .then((response) => {
                  const { chat } = this.state
                  //check reeived chat details having id of logged user id then show chat if not show you're not member of chat
                  const userExistsInUsers = response.users.some(
                    (user) =>
                      user.lg_user_id === String(chat.lg_user_id) &&
                      user.lg_user_table_id === String(chat.lg_user_table_id)
                  )

                  if (
                    (response.groupAdmin.lg_user_id ===
                      String(chat.lg_user_id) &&
                      response.groupAdmin.lg_user_table_id ===
                        String(chat.lg_user_table_id)) ||
                    userExistsInUsers
                  ) {
                    this.setState({
                      chat_server_details: response,
                      chat_backDrop: false,
                      showChatModal: true,
                    })
                  } else {
                    this.setState({ chat_backDrop: false })
                    sweetStatusAlert(
                      "No Access",
                      "You're not added to this chat",
                      "info"
                    )
                  }
                })
                .catch((error) => {
                  this.setState({ chat_backDrop: false })
                  sweetStatusAlert(
                    "Error",
                    "Error getting chat details",
                    "error"
                  )
                })
            } else {
              if (!!this.state.chat.privilege_add) {
                this.setState({ chat_backDrop: false })
                this.toggleCreateGroupModal()
              } else {
                this.setState({ chat_backDrop: false })
                sweetStatusAlert("Oops", "Chat is not created yet!", "info")
              }
            }
          }
        )
      })
      .catch((error) => {
        this.setState({ chat_backDrop: false })
        sweetStatusAlert("Failed", "Failed to get chat details", "error")
      })
  }

  toggleChatModal = (chat) => {
    const { showChatModal } = this.state
    if (!showChatModal) {
      this.setState({selectedFormDetail:null},()=>{
        this.setState({ chat: chat, chat_backDrop: true })
        this.getChatDetails(chat.mid, chat.lg_user_id, chat.lg_user_table_id)
      })
    } else {
      this.setState((prevState) => ({
        showChatModal: !prevState.showChatModal,
      }))
    }
  }

  toggleCreateGroupModal = () => {
    this.setState(
      (prevState) => ({
        showGroupChatAdd: !prevState.showGroupChatAdd,
      }),
      () => {
        if (this.state.showGroupChatAdd) {
          this.getNodeUsersDetailsForCreateChat()
        } else {
          this.setState({ createChatLoading: false })
        }
      }
    )
  }

  getNodeUsersDetailsForCreateChat = async () => {
    this.setState({ memberListLoading: true })
    TreeMainService.getMembersListOfNode(
      this.state.chat.mid,
      this.state.chat.form_list_id,
      this.state.chat.lg_user_id,
      this.state.chat.lg_user_table_id
    )
      .then((response) => {
        const members = JSON.parse(response.data.members)
        const filteredData = members.map((item) => {
          let lg_user_id = String(item.user_id)
          let lg_user_table_id = String(item.user_table_id)
          let name = "Unknown"

          const match = item.data_concat.match(
            /First Name:(.*?)\/Last Name:(.*?)$/
          )
          if (match) {
            name = match[1] + " " + match[2]
          }

          return {
            lg_user_id,
            lg_user_table_id,
            name,
          }
        })
        this.setState(
          (prevState) => ({
            studentList: filteredData,
            checked: filteredData,
          }),
          () => {
            this.setState({ memberListLoading: false })
          }
        )
      })
      .catch((error) => {
        this.setState({ memberListLoading: false })
        sweetStatusAlert("Error", "Error getting members list", "error")
      })
  }

  createNewChat = async () => {
    this.setState({ createChatLoading: true })
    const { chatName } = this.state
    const groupAdmin = {
      name: "Admin",
      lg_user_id: String(this.state.chat.lg_user_id),
      lg_user_table_id: String(this.state.chat.lg_user_table_id),
    }
    const users = this.state.checked
    const { lg_user_id, lg_user_table_id, mid } = this.state.chat

    const newChat = {
      chatName: chatName,
      users: users,
      groupAdmin: groupAdmin,
    }

    if (!chatName) {
      this.setState({ createChatLoading: false })
      sweetStatusAlert("Error", "Please provide chat name", "info")
    } else {
      ChatService.add(newChat)
        .then((response) => {
          if (response._id) {
            const addChat = {
              node_mid: mid,
              create_user_id: lg_user_id,
              create_user_table_id: lg_user_table_id,
              chatId: response._id,
            }

            TreeMainService.addChatInfo(addChat)
              .then((response) => {
                if (response.success) {
                  this.setState({
                    createChatLoading: false,
                    showGroupChatAdd: false,
                  })
                  sweetSuccessAlert(
                    "Success",
                    "Chat created successfully",
                    "success"
                  )
                }
              })
              .catch((error) => {
                this.setState({ createChatLoading: false })
                sweetStatusAlert(
                  "Oops",
                  "Error while adding chat to main DB",
                  "error"
                )
              })
          } else {
            this.setState({ createChatLoading: false })
            sweetStatusAlert("Error", "Error while creating group", "error")
          }
        })
        .catch((error) => {
          this.setState({ createChatLoading: false })
          sweetStatusAlert("Error", "Error while creating group", "error")
        })
    }
  }

  handleToggle = (value) => () => {
    const { checked } = this.state
    const currentIndex = checked.indexOf(value)
    const newChecked = [...checked]

    if (currentIndex === -1) {
      newChecked.push(value)
    } else {
      newChecked.splice(currentIndex, 1)
    }
    this.setState({ checked: newChecked })
  }

  handleToggleAll = (items) => () => {
    const { checked } = this.state
    if (checked.length === 0) {
      this.setState({ checked: items })
    } else if (items.length === checked.length) {
      this.setState({ checked: [] })
    } else {
      const uncheckedItems = items.filter((item) => !checked.includes(item))
      this.setState({
        checked: [...checked, ...uncheckedItems],
      })
    }
  }

  handleAboutUpdate = async () => {
    this.setState({ isAboutLoading: true })
    const { about } = this.state
    const updateAbout = {
      node_mid: about.mid,
      text: JSON.stringify([
        convertToRaw(this.state.contentEditorState.getCurrentContent()),
      ]),
    }
    TreeMainService.updateAboutInfo(updateAbout)
      .then((response) => {
        this.setState({ isAboutLoading: false })
        sweetSuccessAlert("Success", "About updated", "success")
        this.setState({
          showAboutUpdateModal: false,
          contentEditorState: null,
        })
      })
      .catch((error) => {
        this.setState({ isAboutLoading: false })
        sweetStatusAlert("Failed", "Failed to update about", "error")
      })
  }

  handleAboutAdd = async () => {
    this.setState({ isAboutLoading: true })
    const { about } = this.state
    const addAbout = {
      node_mid: about.mid,
      text: JSON.stringify([
        convertToRaw(this.state.contentEditorState.getCurrentContent()),
      ]),
      create_user_id: about.lg_user_id,
      create_user_table_id: about.lg_user_table_id,
    }
    TreeMainService.addAboutInfo(addAbout)
      .then((response) => {
        if (response.success) {
          this.setState({ isAboutLoading: false })
          sweetSuccessAlert("Success", "About added successfully", "success")
          this.setState({
            showAboutUpdateModal: false,
            contentEditorState: null,
          })
        }
      })
      .catch((error) => {
        this.setState({ isAboutLoading: false })
        sweetStatusAlert("Failed", "Failed to add about", "error")
      })
  }

  toggleProgressModal = (progress) => {
    const{showProgressModal} = this.state;
    if(!showProgressModal){
      this.setState({selectedFormDetail:null},()=>{
        this.validator.hideMessages()
        this.validator.purgeFields();
        this.setState({progress:progress, chat_backDrop:true})
        this.getProgressDetails(progress.mid)
      })
    }
    else{
      this.setState(
        (prevState)=>({
        showProgressModal:!prevState.showProgressModal
      })
      )
      this.validator.hideMessages()
      this.validator.purgeFields();
    }
  };

  redirect = async(fmid=undefined, smid=undefined, formid=undefined) => {
    console.log("Fmid=>",fmid);
    console.log("Smid=>",smid);
    console.log("formid=>",formid);
    if(fmid && smid && formid){
      history.push(`/manage-search?fmid=${fmid}&smid=${smid}&formid=${formid}`);
    }else if(fmid && smid && !formid){
      
      const { get_all_forms, form_array } = this.context
      let user_id = sessionStorage.getItem("manage_user_id")
      let user_table_id = sessionStorage.getItem("table_log_id")

      this.setState({highlightCard:smid})

      try {

          this.setState({ formLoading: true });

          if(form_array && form_array.data?.length > 0 ){            

            this.setState({
              selectedMidsForms: form_array.data,
              formLoading:false,
            })
          }
          else{
            await get_all_forms(fmid,-1, user_id, user_table_id)
          }
  
      } catch (error) {
        console.error('Error fetching forms:', error);
        this.setState({ formLoading: false });
      }
      history.push(`/manage-search?fmid=${fmid}&smid=${smid}`);
      // this.handleClickNodeCards(fmid,smid,this.state.hierarchyGridBottomData)
      // history.push(`/manage-search?fmid=${fmid}&smid=${smid}`);//vxfghfj
      
    }else if(fmid && !smid && !formid){
      history.push(`/manage-search?fmid=${fmid}`);
    }else{
      history.push(`/manage-search`);
    }
  }

  handleClickNodeCards = async(fmid,selecetedMid,nodeArray)=>{
    console.log("==============STATE================");
    console.log(this.state);
    
  }

  getProgressDetails = async (node_mid) => {
    ProgressService.getProgressDetails(node_mid).then((response) => {
      if (response.success) {
        if (response.data.length > 0) {
          this.setState({ progress_details: response.data, chat_backDrop: false, showProgressModal: true }, () => {
              const { progress_details } = this.state;
              const endDateTimestamp = new Date(progress_details[progress_details.length - 1]?.end_date).getTime();
              const startDateTimestamp = new Date(progress_details[progress_details.length - 1]?.start_date);
              startDateTimestamp.setHours(0, 0, 0, 0);
              const startDateTimestampTime = startDateTimestamp.getTime()
              const todayTimestamp = new Date().getTime();

              const dayDifference = Math.ceil((endDateTimestamp - startDateTimestampTime) / (1000 * 60 * 60 * 24));

              this.setState({ todayIndex: parseInt(Math.ceil((todayTimestamp - startDateTimestampTime) / (1000 * 60 * 60 * 24))) }, () => {
                  const genarateDayArray = [];

                  for (let i = 0; i <= dayDifference; i++) {
                    const currentDateTimestamp = startDateTimestampTime + i * 24 * 60 * 60 * 1000;
                    const currentDate = new Date(currentDateTimestamp);

                    genarateDayArray.push({
                      value: i + 1,
                      label: `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`,
                    });
                  }
                  this.setState({ dayArray: genarateDayArray }, () => {
                    if (this.state.todayIndex > genarateDayArray.length) {
                      this.setState({ todayIndex: genarateDayArray.length-1 });
                    }

                    let markslist = progress_details.map((item, index) => {
                      let markDate = new Date(item.date).getTime();
                      let startDate = new Date(item.start_date).getTime();
                      let dayMarkDifference = Math.ceil((markDate - startDate) / (1000 * 60 * 60 * 24));

                      return {
                        value: dayMarkDifference,
                        label: item.percentage + "%",
                      };
                    });
                    if(!this.state.dayArray[this.state.todayIndex]){
                      markslist.push({
                        value: this.state.todayIndex - 1,
                        label: "Today",
                      });
                    }

                    this.setState({ marks: markslist });
              });
            });
          });
        } else {
          if (!!this.state.progress.privilege_delete) {
            this.setState({ steps: ["Start Date", "End Date"], chat_backDrop: false, showProgressCreateModal: true });
          } else {
            this.setState({ chat_backDrop: false });
            sweetStatusAlert("Oops", "Progress not initialized yet!", "info");
          }
        }
      } else {
        this.setState({ chat_backDrop: false });
        sweetStatusAlert("Error", "Error getting progress details", "error");
      }
    });
  };

  handleAddProgress = ()=>{
    if (!this.validator.fieldValid('start_date')||!this.validator.fieldValid('end_date')) {
      this.validator.showMessages();
      this.forceUpdate();
    } else {
      sweetConfirmAlert()
        .then(()=>{
        this.setState({progress_loading: true})
        const {progress,start_date,end_date} = this.state;

        const newProgress = {
          node_mid:progress.mid,
          create_user_id:progress.lg_user_id,
          create_user_table_id:progress.lg_user_table_id,
          start_date:start_date,
          end_date:end_date,
          percentage:0,
          date:start_date,
          comment:"Initialize progress"
        }

        ProgressService.add(newProgress)
          .then((response)=>{
            this.setState({progress_loading:false, showProgressCreateModal:false})
            sweetSuccessAlert("Success",response.message,"success")
            this.validator.purgeFields();
          })
          .catch((error)=>{
            this.setState({progress_loading:false})
            sweetStatusAlert("Failed",error.message,"error")
          })
      })
    }
  }

  toggleAddProgress = ()=>{
    const {showProgressCreateModal} = this.state;
    if(!showProgressCreateModal){
      this.validator.hideMessages()
      this.setState({showProgressCreateModal:true})
    }
    else{
      this.validator.hideMessages()
      this.validator.purgeFields();
      this.setState(
        (prevState)=>({
        showProgressCreateModal:!prevState.showProgressCreateModal,
        start_date:null,
        end_date:null
      })
      )
    }
  }

  handleProgressSubmit=()=>{
    if (!this.validator.fieldValid('date') || !this.validator.fieldValid('percentage') || !this.validator.fieldValid('comment')) {
      this.validator.showMessages();
      this.forceUpdate();
    } else {
      sweetConfirmAlert()
        .then(()=>{
        this.setState({progress_loading: true})
        const {progress,progress_details,percentage,comment,date} = this.state;

        const updateProgress = {
          node_mid:progress.mid,
          create_user_id:progress.lg_user_id,
          create_user_table_id:progress.lg_user_table_id,
          start_date:progress_details[progress_details.length-1]?.start_date,
          end_date:progress_details[progress_details.length-1]?.end_date,
          percentage:parseInt(percentage),
          date:date,
          comment:comment
        }

        ProgressService.add(updateProgress)
          .then((response)=>{
            this.setState({progress_loading:false, showProgressModal:false})
            sweetSuccessAlert("Success",response.message,"success")
            this.validator.hideMessages();
            this.validator.purgeFields();
          })
          .catch((error)=>{
            this.setState({progress_loading:false})
            sweetStatusAlert("Failed",error.message,"error")
          })
      })
    }
  }

  valueLabelFormat=(value)=> {
    
    const matchedMark = this.state.dayArray?.find((mark) => mark.value === value);

    const percentageMatchMark = this.state.marks?.find((per)=>per.value ===value )

    if (matchedMark) {
      if(percentageMatchMark){
        return matchedMark.label+" "+percentageMatchMark.label
      }
      return matchedMark.label;
    }
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');

    const formattedDate = `${year}-${month}-${day}`;

    return formattedDate;
  }

  deleteProgressItem=(progress)=>{
    sweetConfirmAlert()
      .then(()=>{
        this.setState({progress_loading:true})
        ProgressService.deleteProgress(progress.id)
          .then((response)=>{
          if(response.success){
            sweetSuccessAlert("Success","Progress status deleted","success")
            this.setState({progress_loading:false})
            this.toggleProgressModal()
          }
            else{
            sweetSuccessAlert("Oops","Failed to delete Progress status","error")
            this.setState({progress_loading:false})
          }
        })

      })
      .catch((error) => {
        this.setState({ isAboutLoading: false })
        sweetStatusAlert("Failed", "Failed to add about", "error")
      })
  }

  render() {
    const {
      isLoading,
      loadingNode,
      hierarchyGridTopData,
      hierarchyGridBottomData,
      groupTitle,
      mcode,
      displayOrder,
      about,
      isAboutLoading,
      about_details,
      chat,
      createChatLoading,
      chat_backDrop,
      checked,
      studentList,
      memberListLoading,
      progress,
      steps,
      start_date,
      end_date,
      progress_loading,
      progress_details,
      marks,
      dayArray,
      todayIndex,
      isCardSectionVisible,
      isMobile,
      selectedMidsForms,
      selectedMid,
      selectedFormDetail,
      user_id,
      user_table_id,
      titles,
      isHideForExam
    } = this.state;
    this.validator.purgeFields();
    const {node_array} = this.context
    
    return (
      <>
        <AdminTemplate>
          <ContentWrapper>
            <Card>
              <CardHeader>
                <CardTitle
                  cardLabel={
                    hierarchyGridTopData.length > 0 &&
                    hierarchyGridTopData[hierarchyGridTopData.length - 1].title
                  }
                />
              </CardHeader>
              {isLoading ? (
                <PageSpinner id="show" text="Loading, Please wait!" />
              ) : (
                <CardBody>
                  { hierarchyGridTopData && hierarchyGridTopData.length > 0 && (
                    <Breadcrumbs
                      user_id={this.state.user_id}
                      user_table_id={this.state.user_table_id}
                      toggleModal={this.toggleModal}
                      hierarchyGridTopData={hierarchyGridTopData}
                      getDashboardStats={this.getDashboardStats}
                      redirect={this.redirect}
                    />
                  )}
                  <div className="">
                    <Grid container spacing={1} style={{ padding: "10px" }}>
                      {/* Left column with HirearchyCard components */}
                      {isHideForExam && <Grid
                        item
                        xs={12}
                        sm={12}
                        md={2}
                        lg={2}
                        className={`card-section fade-in"  ${
                          this.state.isCardSectionVisible
                            ? ""
                            : "card-section-hidden"
                        }`}
                      >
                        {loadingNode ? (
                          <AddCard toggleModal={this.toggleModal}
                            loading={loadingNode}/>
                        ) : (
                          <>
                            {node_array.length > 0 &&
                              node_array.map(
                                (cardData, index) => {
                                  return (
                                  <HirearchyCard
                                    singleNodeParentParent = {node_array.length === 1 ? hierarchyGridTopData[hierarchyGridTopData.length-1]: undefined}
                                    key={index}
                                    cardData={cardData}
                                    redirect = {()=>this.redirect(cardData.pid, cardData.mid)}
                                    redirectParent={
                                      this.redirect
                                    }
                                    getDashboardStats={
                                      this.getDashboardStats
                                    }
                                    toggleUpdateModal={
                                      this.toggleUpdateModal
                                    }
                                    toggleInsertModal = {
                                      this.toggleModal
                                    }
                                    user_id={this.state.user_id}
                                    highlightCard={this.state.highlightCard}
                                    user_table_id={this.state.user_table_id}
                                    setNodeLoading={this.setNodeLoading}
                                    toggleAboutModal={this.toggleAboutModal}
                                    toggleChatModal={this.toggleChatModal}
                                    toggleProgressModal= {this.toggleProgressModal}
                                    setHierarchyCardInsertion = {() =>{
                                      this.setState({hierarchyCardInsertion:true})
                                    }}
                                    titles={titles}
                                  />
                                )}
                              )}
                            {!!this.state.hierarchyGridTopData[
                              this.state.hierarchyGridTopData.length - 1
                            ] &&
                              !!this.state.hierarchyGridTopData[
                                this.state.hierarchyGridTopData.length - 1
                              ].flg_add_node_sibling && (
                                <AddCard toggleModal={this.toggleModal} />
                              )}
                          </>
                        )}
                      </Grid>}

                      {/* Right column with Tabs */}
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={isHideForExam ? 10 : 12}
                        lg={isHideForExam ? 10 : 12}
                        className="fade-in"
                      >
                        <div className="tab-section">
                          {isHideForExam &&  <Box
                            sx={{ 
                              // borderBottom: 1, borderColor: "divider" 
                            }}
                          >
                            {this.state.formLoading ?

                                <Tabs
                                  variant="scrollable"
                                  scrollButtons="auto"
                                >

                                  <Tab
                                    key={0}
                                    label={'Loading...'}
                                  />

                                </Tabs> 

                              :
                              // <></>
                                  (selectedMidsForms && selectedMid &&
                                      <TabSection
                                        formArray= {selectedMidsForms}
                                        pid={selectedMid.pid}
                                        title ={selectedMid.title}
                                        setFormDetail={this.setFormDetail}
                                        selectedFormDetail={selectedFormDetail}
                                    />
                                  )
                            }
                          </Box>} 
                          {this.state.formLoading ? (
                            <div></div>
                          ) : (
                            <div className="" style={{ maxHeight: "90vh", overflowY: "auto" }}>
                              {!!selectedMidsForms && selectedMidsForms.length > 0 && (
                                this.handleApplicationSelect(selectedFormDetail)
                              )}
                            </div>
                          )}
                        </div>
                      
                      </Grid>
                      
                      <button
                        type="button"
                        className="menu-icon"
                        onClick={this.toggleCardSection}
                        style={{ display: !isMobile ? 'none' : 'inline-block', position:'absolute', top:'8px', right:'8px' }}
                      >
                        <GridViewRoundedIcon />
                      </button>

                    </Grid>
                  </div>
                </CardBody>
              )}
            </Card>
          </ContentWrapper>

          {/* Card Section model */}
          <Modal
            size="lg"
            centered
            onHide={() => this.setState({ isCardSectionVisible: false })}
            show={isCardSectionVisible}
          >
            <Modal.Header className="d-flex justify-content-end" closeButton></Modal.Header>
            <Modal.Body>
              <>
                {hierarchyGridBottomData.length > 0 &&
                  hierarchyGridBottomData.map(
                    (cardData, index) => (
                      <HirearchyCard
                      singleNodeParentParent = {hierarchyGridBottomData.length === 1 ? hierarchyGridTopData[hierarchyGridTopData.length-1]: undefined}
                      key={index}
                      cardData={cardData}
                      redirect = {()=>this.redirect(cardData.pid, cardData.mid)}
                      redirectParent={
                        this.redirect
                      }   
                      getDashboardStats={
                        this.getDashboardStats
                      }
                      toggleUpdateModal={
                        this.toggleUpdateModal
                      }
                      toggleInsertModal = {
                        this.toggleModal
                      }
                      user_id={this.state.user_id}
                      highlightCard={this.state.highlightCard}
                      user_table_id={this.state.user_table_id}
                      setNodeLoading={this.setNodeLoading}
                      toggleAboutModal={this.toggleAboutModal}
                      toggleChatModal={this.toggleChatModal}
                      toggleProgressModal= {this.toggleProgressModal}
                      setHierarchyCardInsertion = {() =>{
                        this.setState({hierarchyCardInsertion:true})
                      }}
                      titles={titles}
                      />
                    )
                                  )}
                {!!this.state.hierarchyGridTopData[
                  this.state.hierarchyGridTopData.length - 1
                ] &&
                  !!this.state.hierarchyGridTopData[
                    this.state.hierarchyGridTopData.length - 1
                  ].flg_add_node_sibling && (
                    <AddCard toggleModal={this.toggleModal} />
                  )}
              </>
            </Modal.Body>
          </Modal>

          {/*Defining insert model*/}
          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={this.state.showInsertModal}
            onHide={() => this.toggleModal()}
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {/* {"L" === this.state.insertType
                  ? `You are going to create an item in-between two items: ${this.state.pid}`
                  : `Create a leaf item as a child of item: ${this.state.pid}`}{" "} */}
                {"L" === this.state.insertType
                  ? `You are going to create an item`
                  : `You are going to create an item`}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Row className="my-5">
                  <Form.Group
                    as={Col}
                    md="6"
                    controlId="exampleForm.ControlInput1"
                    className="mb-3"
                  >
                    <Form.Label>ID</Form.Label>
                    <Form.Control
                      type="text"
                      name="mcode"
                      placeholder="ID"
                      onChange={this.handleChange}
                    />
                    {this.validator.message(
                      "mcode",
                      this.state.mcode,
                      "required",
                      {
                        className: "text-danger",
                        messages: {
                          required: "Id is required.",
                        },
                      }
                    )}
                  </Form.Group>
                  <Form.Group
                    as={Col}
                    md="6"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Main Title</Form.Label>
                    <Form.Control
                      type="text"
                      name="title"
                      placeholder="Main Title"
                      onChange={this.handleChange}
                      className="mb-3"
                    />
                    {this.validator.message(
                      "title",
                      this.state.title,
                      "required",
                      {
                        className: "text-danger",
                        messages: {
                          required: "Main title is required.",
                        },
                      }
                    )}
                  </Form.Group>
                  <Form.Group
                    as={Col}
                    md="6"
                    controlId="exampleForm.ControlInput1"
                    className="my-3"
                  >
                    <Form.Label>Group Title</Form.Label>
                    <Form.Select
                      aria-label="Default select example"
                      name="groupTitle"
                      value={groupTitle}
                      onChange={this.handleChange}
                      className="mb-3"
                    >
                      <option value="">Select</option>
                      {titles.length>0?(titles.map((title)=>(
                          <option key={title.group_id} value={title.group_id}>
                            {title.group_title}
                          </option>
                        ))):(
                        <option value="">No titles available</option>
                      )}
                    </Form.Select>
                    {this.validator.message(
                      'groupTitle',
                      this.state.groupTitle,
                      'required|max:20', {
                        className: "text-danger",
                        messages: {
                          required: "Group title is required.",
                        },
                      })}
                  </Form.Group>

                  <Form.Group
                    as={Col}
                    md="6"
                    controlId="exampleForm.ControlInput1"
                    className="mt-3"
                  >
                    <Form.Label>Display Order</Form.Label>
                    <Form.Control
                      type="number"
                      name="displayOrder"
                      step={1}
                      min={0}
                      max={100}
                      value={displayOrder}
                      defaultValue={0}
                      placeholder="Display Order"
                      onChange={this.handleChange}
                      className="mb-3"
                    />
                  </Form.Group>
                  <Form.Group
                    as={Col}
                    md="6"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Row className="px-0 d-flex justify-content-between">
                      <Form.Label className="col-auto px-0">
                        Hide this item
                      </Form.Label>
                      <div className="col-auto px-0">
                        <Form.Check
                          type="checkbox"
                          name="flg_node_hide"
                          onChange={this.handleChange}
                          className="calendar-checkbox"
                        />
                      </div>
                    </Row>
                  </Form.Group>
                </Row>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="primary"
                style={ addBtnStyle }
                onClick={(event) => this.handleSubmit(event)}
              >
                Add Item
              </Button>
              <Button
                id="modal-close-button"
                style={ closeBtnStyle }
                onClick={() => this.toggleModal()}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>

          {/*Defining update model*/}
          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={this.state.showUpdateModal}
            onHide={() => this.toggleUpdateModal()}
          >
            <Modal.Header closeButton>
              <Modal.Title>You are going to update the item</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Row className="my-5">
                  <Form.Group
                    as={Col}
                    md="6"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>ID</Form.Label>
                    <Form.Control
                      type="text"
                      name="mcode"
                      placeholder="ID"
                      value={mcode}
                      onChange={this.handleChange}
                    />
                    {this.validator.message(
                      "mcode",
                      this.state.mcode,
                      "required",
                      {
                        className: "text-danger",
                        messages: {
                          required: "Id is required.",
                        },
                      }
                    )}
                  </Form.Group>
                  <Form.Group
                    as={Col}
                    md="6"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Main Title</Form.Label>
                    <Form.Control
                      type="text"
                      name="title"
                      placeholder="Main Title"
                      value={this.state.title}
                      onChange={this.handleChange}
                    />
                    {this.validator.message(
                      "title",
                      this.state.title,
                      "required",
                      {
                        className: "text-danger",
                        messages: {
                          required: "Main title is required.",
                        },
                      }
                    )}
                  </Form.Group>

                </Row>
                <Row className="my-5">
                  <Form.Group
                    as={Col}
                    md="6"
                    controlId="exampleForm.ControlInput1"
                    className="my-3"
                  >
                    <Form.Label>Group Title</Form.Label>
                    <Form.Select
                      aria-label="Default select example"
                      name="groupTitle"
                      value={groupTitle}
                      onChange={this.handleChange}
                    >
                      <option value="">Select</option>
                      {titles.length>0?(titles.map((title)=>(
                          <option key={title.group_id} value={title.group_id}>
                            {title.group_title}
                          </option>
                        ))):(
                        <option value="">No titles available</option>
                      )}
                    </Form.Select>
                    {this.validator.message(
                      'groupTitle',
                      this.state.groupTitle,
                      'required|max:20', {
                        className: "text-danger",
                        messages: {
                          required: "Group title is required.",
                        },
                      })}
                  </Form.Group>

                  <Form.Group
                    as={Col}
                    md="6"
                    controlId="exampleForm.ControlInput1"
                    className="mt-3"
                  >
                    <Form.Label>Display Order</Form.Label>
                    <Form.Control
                      type="number"
                      name="displayOrder"
                      step={1}
                      min={0}
                      max={100}
                      placeholder="Display Order"
                      value={this.state.displayOrder}
                      onChange={this.handleChange}
                      className="mb-3"
                    />
                  </Form.Group>
                  <Form.Group
                    as={Col}
                    md="6"
                  >
                    <Row className="px-0 d-flex justify-content-between">
                      <Form.Label className="col-auto px-0">
                        Hide this item
                      </Form.Label>
                      <div className="col-auto px-0">
                        <Form.Check
                          type="checkbox"
                          name="flg_node_hide"
                          onChange={this.handleChange}
                          checked={!!this.state.flg_node_hide}
                        />
                      </div>
                    </Row>
                  </Form.Group>
                </Row>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="primary"
                style={ addBtnStyle }
                onClick={(event) => this.handleUpdateSubmit(event)}
              >
                Update
              </Button>
              <Button
                id="modal-close-button"
                style={ closeBtnStyle }
                onClick={() => this.toggleUpdateModal()}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={this.state.showProgressCreateModal}
            onHide={() => this.toggleAddProgress()}
          >
            <Modal.Header closeButton>
              <Modal.Title>{progress?.form_display_title?progress.form_display_title:'Not available'}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              {progress_loading?(
                <div style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                  <CircularProgress />
                </div>
              ):(
                <Form>
                  <Row className="my-5">
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>Add start date</Form.Label>

                      <Form.Control
                        type="datetime-local"
                        name="start_date"
                        placeholder="Start Date"
                        onChange={this.handleChange}
                      />
                      {this.validator.message(
                        "start_date",
                        this.state.start_date,
                        "required",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The start date field is required",
                          },
                        }
                      )}

                    </Form.Group>

                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>Add end date</Form.Label>

                      <Form.Control
                        type="datetime-local"
                        name="end_date"
                        placeholder="End Date"
                        onChange={this.handleChange}
                        disabled={!this.state.start_date}
                        min={new Date().toISOString().slice(0, 16)}
                      />

                      {this.validator.message(
                        "end_date",
                        this.state.end_date,
                        "required|dateAfter",
                        {
                          className: "text-danger",
                          messages: {
                            required: "The end date field is required",
                          },
                        }
                      )}
                    </Form.Group>
                  </Row>

                  <Row className="my-5">
                    <Box sx={{ width: '100%' }}>
                      <Stepper activeStep={2} alternativeLabel>
                        {steps?.map((label,index) => {
                          const labelProps = {};
                          if (index===0) {
                            labelProps.optional = (
                              <Typography color="success">
                                {start_date?start_date:""}
                              </Typography>
                            );
                      
                                }
                                else if(index === steps.length-1){
                            labelProps.optional = (
                              <Typography color="error">
                                {end_date?end_date:""}
                              </Typography>
                            );

                            labelProps.error = true;
                          }
                          return(
                            <Step key={label}>
                              <StepLabel {...labelProps}>{label}</StepLabel>
                            </Step>
                          )
                        })}
                      </Stepper>
                    </Box>
                  </Row>
                </Form>
              )}

            </Modal.Body>

            <Modal.Footer>
              <Button variant="primary"
                style={ addBtnStyle }
                onClick={this.handleAddProgress}
              >
                Save changes
              </Button>
              <Button
                id="modal-close-button"
                style={ closeBtnStyle }
                onClick={() => this.toggleAddProgress()}
              >
                Close
              </Button>
            </Modal.Footer>

          </Modal>

          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={this.state.showAboutUpdateModal}
            onHide={() => this.toggleAboutModal()}
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {/* {about?.form_display_title
                  ? about.form_display_title
                  : "Not available"} */}
              </Modal.Title>
            </Modal.Header>
            {isAboutLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Spinner />
              </div>
            ) : (
              <Modal.Body>
                {!!about?.privilege_edit ? (
                  <Form>
                    <Row className="my-5">
                      <Form.Group
                        as={Col}
                        md="12"
                        controlId="exampleForm.ControlInput1"
                      >
                        {/* <Form.Label>About</Form.Label> */}
                        <div>
                          <CustomEditor
                            editorState={
                              this.state.contentEditorState
                                ? this.state.contentEditorState
                                : null
                            }
                            onEditorStateChange={this.onContentEditorChange}
                            customOptions={[
                              "inline",
                              "blockType",
                              "fontSize",
                              "fontFamily",
                              "list",
                              "textAlign",
                              "colorPicker",
                              "embedded",
                              "emoji",
                              "image",
                              "remove",
                              "history",
                            ]}
                          />
                        </div>
                      </Form.Group>
                    </Row>
                  </Form>
                ) : (
                  <div>
                    <Editor
                      editorState={
                        this.state.contentEditorState
                          ? this.state.contentEditorState
                          : null
                      }
                      toolbarClassName="toolbarClassName"
                      wrapperClassName="wrapperClassName"
                      editorClassName="editorClassName"
                      toolbarHidden={true}
                    />
                  </div>
                )}
              </Modal.Body>
            )}
            <Modal.Footer>
              {about?.privilege_edit &&
                (about_details?.id ? (
                  <Button
                    variant="primary"
                    style={ addBtnStyle }
                    onClick={() => this.handleAboutUpdate()}
                  >
                    Update
                  </Button>
                ) : (
                  <Button
                    variant="primary"
                    style={ addBtnStyle }
                    onClick={() => this.handleAboutAdd()}
                  >
                    Add
                  </Button>
                ))}
                <Button
                  id="modal-close-button"
                  style={ closeBtnStyle }
                  onClick={() => this.toggleAboutModal()}
                >
                  Close
                </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={this.state.showGroupChatAdd}
            onHide={() => this.toggleCreateGroupModal()}
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {chat?.form_display_title
                  ? chat.form_display_title
                  : "Not available"}
              </Modal.Title>
            </Modal.Header>
            {createChatLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Spinner />
              </div>
            ) : (
              <Modal.Body>
                <Form>
                  <Row className="my-5">
                    <Form.Group
                      as={Col}
                      md="8"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>Group Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="chatName"
                        placeholder="Group Name"
                        onChange={this.handleChange}
                      />
                    </Form.Group>

                    <Form.Group
                      as={Col}
                      md="4"
                      controlId="exampleForm.ControlInput1"
                    >
                      {checked.length > 1 ? (
                        <div>
                          <Form.Label>Create Group</Form.Label>
                          <Button
                            variant="primary"
                            onClick={() => this.createNewChat()}
                          >
                            Create
                          </Button>
                        </div>
                      ) : (
                        <div>
                          <i style={{ color: "red", fontSize: "10px" }}>
                            Please select atleast 2 users to create chat
                          </i>
                          <Button
                            variant="primary"
                            onClick={() => this.createNewChat()}
                            disabled
                          >
                            Create
                          </Button>
                        </div>
                      )}
                    </Form.Group>
                  </Row>

                  <Row className="my-5">
                    <List
                      as={Col}
                      md="6"
                      subheader={
                        <ListSubheader
                          component="div"
                          id="nested-list-subheader"
                        >
                          <Row className="my-5">
                            <h6 className="col-md-7">
                              <b>Group Chat Members</b>
                            </h6>
                          </Row>
                        </ListSubheader>
                      }
                      sx={{
                        width: "100%",
                        maxWidth: 360,
                        bgcolor: "background.paper",
                        position: "relative",
                        overflow: "auto",
                        maxHeight: 300,
                        "& ul": { padding: 0 },
                      }}
                    >
                      <ListSubheader component="div" id="nested-list-subheader">
                        <Checkbox
                          onClick={this.handleToggleAll(studentList)}
                          checked={checked.length > 0}
                          disabled={studentList.length === 0}
                          inputProps={{
                            "aria-label": "all items selected",
                          }}
                          style ={{
                            color: "#5458AF",
                          }}
                        />
                        {checked.length +
                          "/" +
                          studentList.length +
                          " " +
                          "selected"}
                      </ListSubheader>
                      <ListSubheader
                        component="div"
                        id="nested-list-subheader"
                        disablePadding
                      ></ListSubheader>
                      {!memberListLoading ? (
                        studentList.length > 0 ? (
                          studentList.map((item) => (
                            <ListItem
                              key={item.lg_user_id}
                              secondaryAction={
                                <Checkbox
                                  edge="end"
                                  onChange={this.handleToggle(item)}
                                  checked={checked.indexOf(item) !== -1}
                                  inputProps={{ "aria-labelledby": item }}
                                  style ={{
                                    color: "#5458AF",
                                  }}
                                />
                              }
                              disablePadding
                            >
                              <ListItemButton>
                                <ListItemAvatar>
                                  <Avatar
                                    alt={item.name ? item.name : ""}
                                    src={item.name ? item.name : ""}
                                  />
                                </ListItemAvatar>
                                <ListItemText
                                  id={item.lg_user_id ? item.lg_user_id : null}
                                  primary={item.name ? item.name : "Unknown"}
                                  secondary={
                                    item.lg_user_id
                                      ? item.lg_user_id
                                      : "not available"
                                  }
                                />
                              </ListItemButton>
                            </ListItem>
                          ))
                        ) : (
                          <div>
                            <ListItemButton component="a">
                              <ListItemIcon sx={{ fontSize: 20 }}>
                                <ErrorIcon />
                              </ListItemIcon>
                              <ListItemText
                                sx={{ my: 0 }}
                                primary="No members found"
                                primaryTypographyProps={{
                                  fontSize: 20,
                                  fontWeight: "medium",
                                  letterSpacing: 0,
                                }}
                              />
                            </ListItemButton>
                          </div>
                        )
                      ) : (
                        <Box sx={{ width: 300 }}>
                          <Skeleton />
                          <Skeleton animation="wave" />
                          <Skeleton animation={false} />
                        </Box>
                      )}
                    </List>

                  </Row>
                </Form>

              </Modal.Body>
            )}

          </Modal>

          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={this.state.showProgressModal}
            onHide={() => this.toggleProgressModal()}
          >

            <Modal.Header closeButton>
              <Modal.Title>{progress?.form_display_title?progress.form_display_title:'Not available'}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              {progress_loading?(
                <div style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                  <CircularProgress />
                </div>
              ):(
                <Form>
                  <Row className="my-5">
                    <Box sx={{ width: '100%'}}>

                      <Typography gutterBottom>Progress Bar</Typography>
                      <IOSSlider
                        aria-label="ios slider"
                        value={todayIndex}
                        marks={marks}
                        min={dayArray[0]?.value}
                        max={dayArray[dayArray.length-1]?.value}
                        step={1}
                        valueLabelDisplay="on"
                        getAriaValueText={this.valueLabelFormat}
                        valueLabelFormat={this.valueLabelFormat}
                      />
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          mt: -2,
                        }}
                      >
                        <TinyText>Start Date : {dayArray[0]?.label}</TinyText>
                        <TinyText>End Date :{dayArray[dayArray.length-1]?.label}</TinyText>
                      </Box>
                    </Box>
                  </Row>

                  <Row className="my-5">
                    
                        <List dense sx={{
                        width: '100%',
                        maxWidth: 360,
                        bgcolor: 'background.paper',
                        position: 'relative',
                        overflow: 'auto',
                        maxHeight: 300,
                        '& ul': { padding: 0 },
                      }}>

                      {progress_details?.map((progressItem,index) => {
                        return (
                          <div key={index}>
                            <ListItem 
                                alignItems="flex-start" 
                                key={index}
                                >
                              {!!progress.privilege_delete &&
                                <React.Fragment>
                                  <ListItemSecondaryAction>
                                    <IconButton edge="end" aria-label="delete" onClick={() => this.deleteProgressItem(progressItem)}>
                                      <DeleteIcon color="error" />
                                    </IconButton>
                                  </ListItemSecondaryAction>
                                </React.Fragment>
                              }

                              <ListItemAvatar>
                                <Avatar>{progressItem?.percentage+"%"}</Avatar>
                              </ListItemAvatar>
                              <ListItemText
                                primary={progressItem.date}
                                secondary={
                                  <React.Fragment>
                                    {progressItem.comment?progressItem.comment:""}
                                  </React.Fragment>
                                }
                              />
                            </ListItem>
                            <Divider variant="inset" component="li" />
                          </div>
                        );
                      })}
                    </List>

                    {!!progress && !!progress.privilege_add &&

                          <Box sx={{width: '100%',maxWidth: 360, marginLeft:'10px'}}>
                                                    
                        <Form.Label>Add date</Form.Label>

                        <Form.Control
                          type="datetime-local"
                          name="date"
                          placeholder="Date"
                          onChange={this.handleChange}
                        />
                        {this.validator.message(
                          "date",
                          this.state.date,
                          "required|dateLastProgressAfter",
                          {
                            className: "text-danger",
                            messages: {
                              required: "The date field is required",
                            },
                          }
                        )}

                        <Form.Label>Percentage covered</Form.Label>

                        <Form.Control
                          type="number"
                          name="percentage"
                          placeholder="Percentage covered"
                          onChange={this.handleChange}
                        />
                        {this.validator.message(
                          "percentage",
                          this.state.percentage,
                          "required|percentageAfter|numeric|between:1,100",
                          {
                            className: "text-danger",
                            messages: {
                              required: "The percentage field is required",
                            },
                          }
                        )}

                        <Form.Label>Comment</Form.Label>

                        <Form.Control
                          type="text"
                          name="comment"
                          placeholder="Comment"
                          onChange={this.handleChange}
                        />
                        {this.validator.message(
                          "comment",
                          this.state.comment,
                          "required",
                          {
                            className: "text-danger",
                            messages: {
                              required: "The comment field is required",
                            },
                          }
                        )}

                      </Box>
                    }
                        
                  </Row>
                </Form>
              )}
            </Modal.Body>

            <Modal.Footer>
              {!!progress && !!progress.privilege_add &&
                <Button variant="primary"
                  style={ addBtnStyle }
                  onClick={()=>this.handleProgressSubmit()}
                >
                  Save changes
                </Button>
              }
              <Button
                id="modal-close-button"
                style={ closeBtnStyle }
                onClick={() => this.toggleProgressModal()}
              >
                Close
              </Button>
            </Modal.Footer>

          </Modal>

          {/* {showProgressCreateModal &&
            <Progress showProgressCreateModal={showProgressCreateModal} progress={progress} />
          } */}

          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={this.state.showProgressModal}
            onHide={() => this.toggleProgressModal()}
          >

            <Modal.Header closeButton>
              <Modal.Title>Syllabus Coverage or Timeline</Modal.Title>
              {/* <Modal.Title>{progress?.form_display_title?progress.form_display_title:'Not available'}</Modal.Title> */}
            </Modal.Header>

            <Modal.Body>
              {progress_loading?(
                <div style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                  <CircularProgress />
                </div>
              ):(
                <Form>
                  <Row className="my-5">
                    <Box sx={{ width: '100%'}}>

                      {/* <Typography gutterBottom>Progress Bar</Typography> */}
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          fontSize: '3px',
                          mt: -1,
                        }}
                      >
                        <TinyText sx={{ fontSize: '10px',fontWeight: 'bold'}}>Start Date : {dayArray[0]?.label}</TinyText>
                        <TinyText sx={{ fontSize: '10px',fontWeight: 'bold'}}>End Date :{dayArray[dayArray.length-1]?.label}</TinyText>
                      </Box>
                      <IOSSlider
                        aria-label="ios slider"
                        value={todayIndex}
                        marks={marks}
                        min={dayArray[0]?.value}
                        max={dayArray[dayArray.length-1]?.value}
                        step={1}
                        valueLabelDisplay="on"
                        getAriaValueText={this.valueLabelFormat}
                        valueLabelFormat={this.valueLabelFormat}
                        onChange={(event,value)=>this.setState({todayIndex:value})}
                        sx={{ color: '#5458AF'}}
                      />

                    </Box>
                  </Row>

                  <Row className="my-5">
                    
                        <List dense sx={{
                        width: '100%',
                        maxWidth: 360,
                        bgcolor: 'background.paper',
                        position: 'relative',
                        overflow: 'auto',
                        maxHeight: 300,
                        '& ul': { padding: 0 },
                      }}>

                      {progress_details?.map((progressItem,index) => {
                        return (
                          <div key={index}>
                            <ListItem
                              alignItems="flex-start"
                              key={index}
                              style={{marginBottom: '10px'}}
                            >
                              {!!progress.privilege_delete &&
                                <React.Fragment>
                                  <ListItemSecondaryAction>
                                    {/* <IconButton edge="end" aria-label="delete" onClick={() => this.deleteProgressItem(progressItem)}>
                                            <DeleteIcon color="error" />
                                        </IconButton> */}
                                    <Button
                                      className="btn btn-icon btn-danger btn-sm m-1 flaticon-delete"
                                      title="Delete Details"
                                    />
                                  </ListItemSecondaryAction>
                                </React.Fragment>
                              }

                              <ListItemAvatar>
                                <Avatar style={{ backgroundColor: '#5458AF'}}>
                                  {progressItem?.percentage + "%"}
                                </Avatar>
                              </ListItemAvatar>
                              <ListItemText
                                primary={progressItem.date}
                                secondary={
                                  <React.Fragment>
                                    {progressItem.comment?progressItem.comment:""}
                                  </React.Fragment>
                                }
                              />
                            </ListItem>
                            <Divider variant="inset" component="li" />
                          </div>
                        );
                      })}
                    </List>

                    {!!progress && !!progress.privilege_add &&

                          <Box sx={{width: '100%',maxWidth: 360, marginLeft:'10px'}}>
                                                    
                        <Form.Label>Add date</Form.Label>

                        <Form.Control
                          type="datetime-local"
                          name="date"
                          placeholder="Date"
                          onChange={this.handleChange}
                        />
                        {this.validator.message(
                          "date",
                          this.state.date,
                          "required|dateLastProgressAfter",
                          {
                            className: "text-danger",
                            messages: {
                              required: "The date field is required",
                            },
                          }
                        )}

                        <Form.Label>Percentage covered</Form.Label>

                        <Form.Control
                          type="number"
                          name="percentage"
                          placeholder="Percentage covered"
                          onChange={this.handleChange}
                        />
                        {this.validator.message(
                          "percentage",
                          this.state.percentage,
                          "required|percentageAfter|numeric|between:1,100",
                          {
                            className: "text-danger",
                            messages: {
                              required: "The percentage field is required",
                            },
                          }
                        )}

                        <Form.Label>Comment</Form.Label>

                        <Form.Control
                          type="text"
                          name="comment"
                          placeholder="Comment"
                          onChange={this.handleChange}
                        />
                        {this.validator.message(
                          "comment",
                          this.state.comment,
                          "required",
                          {
                            className: "text-danger",
                            messages: {
                              required: "The comment field is required",
                            },
                          }
                        )}

                      </Box>
                    }
                        
                  </Row>
                </Form>
              )}
            </Modal.Body>

            <Modal.Footer>
              {!!progress && !!progress.privilege_add &&
                <Button variant="primary"
                style={ addBtnStyle }
                  onClick={()=>this.handleProgressSubmit()}
                >
                  Save changes
                </Button>
              }
              <Button
                id="modal-close-button"
                style={ closeBtnStyle }
                onClick={() => this.toggleProgressModal()}
              >
                Close
              </Button>
            </Modal.Footer>

          </Modal>

          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={chat_backDrop}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </AdminTemplate>
      </>
    )
  }
}

export default searchComponent;

const iOSBoxShadow =
  '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)';

const IOSSlider = styled(Slider)(({ theme }) => ({
  color: theme.palette.mode === 'dark' ? '#3880ff' : '#3880ff',
  height: 10,
  padding: '15px 0',
  '& .MuiSlider-thumb': {
    height: 60,
    width: 2,
    backgroundColor: 'red',
    boxShadow: iOSBoxShadow,
    '&:focus, &:hover, &.Mui-active': {
      boxShadow:
        '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.3),0 0 0 1px rgba(0,0,0,0.02)',
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        boxShadow: iOSBoxShadow,
      },
    },
  },
  '& .MuiSlider-valueLabel': {
    fontSize: 12,
    fontWeight: 'normal',
    top: -6,
    backgroundColor: 'unset',
    color: theme.palette.text.primary,
    '&:before': {
      display: 'none',
    },
    '& *': {
      background: 'transparent',
      color: theme.palette.mode === 'dark' ? '#fff' : '#000',
    },
  },
  '& .MuiSlider-track': {
    border: 'none',
  },
  '& .MuiSlider-rail': {
    opacity: 0.5,
    backgroundColor: '#bfbfbf',
  },
  '& .MuiSlider-mark': {
    backgroundColor: '#bfbfbf',
    height: 25,
    width: 5,
    '&.MuiSlider-markActive': {
      opacity: 1,
      backgroundColor: 'currentColor',
    },
  },
}));

const TinyText = styled(Typography)({
  fontSize: '1rem',
  fontWeight: 500,
  letterSpacing: 0.2,
});

